import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { AdminProctorDetailsFormProvider, useAdminProctorDetails } from '../../providers';
import { AdminProctorDetailsFormLogic } from '../admin-proctor-details-form-logic';
import { AdminProctorDetailsReadonlyField } from '../admin-proctor-details-readonly-field';

export default function AdminProctorDetailsPermissionUpdate() {
  const hasPermissionUpdate = useHasPermission(
    APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.UPDATE,
  );

  const { proctor } = useAdminProctorDetails();

  if (hasPermissionUpdate) {
    return (
      <AdminProctorDetailsFormProvider initialValues={proctor}>
        <AdminProctorDetailsFormLogic />
      </AdminProctorDetailsFormProvider>
    );
  } else {
    return <AdminProctorDetailsReadonlyField />;
  }
}
